import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SsoSecurityService {

	constructor(
		private http: HttpClient
	) { }
	
	async getPasswordLoginEnabled(): Promise<boolean> {
		let url = '/aw-server/rest/security/passwordLoginEnabled';
		try {
			return await firstValueFrom(this.http.get<any>(url, {}));
		} catch (error) {
			return Promise.reject(error);
		}
	}
	
	async getLdapLoginEnabled(): Promise<boolean> {
		let url = '/aw-server/rest/security/ldapLoginEnabled';

		try {
			const response = await firstValueFrom(this.http.get<any>(url));
			return response || false;
		} catch (error) {
			return Promise.reject(error);
		}
	}
	
	async getIDPSelection(): Promise<any> {
		let url = '/aw-server/rest/security/idpSelection';

		try {
			const response = await firstValueFrom(this.http.get<any>(url));
			return response?.data || {};
		} catch (error) {
			return Promise.reject(error);
		}
	}
	
	async getAzureEnabled(): Promise<boolean> {
		let url = '/aw-server/rest/security/azureLoginEnabled';

		try {
			const response = await firstValueFrom(this.http.get<any>(url));
			return response || false;
		} catch (error) {
			return Promise.reject(error);
		}
	}	
}
